module.exports = __webpack_public_path__ + "static/media/location.5da2a17b.svg";